export default {
  "home": {
    "edit_profile": "Modifier le profil",
    "logout": "Déconnexion",
    "search": "Rechercher",
    "invite_text": "Inviter des amis peut vous faire gagner du temps de recharge gratuit.",
    "invite_btn": "Inviter",
    "map": "Carte",
    "map_text": "Localiser une station",
    "order": "Commande",
    "order_text": "Vérifiez votre commande",
    "promos": "Promotions",
    "payment_methods": "Moyens de paiement",
    "faq": "FAQ",
    "help": "Aide",
    "about_us": "À propos de nous",
    "settings": "Paramètres"
  },
  "login": {
    "welcome": "Bienvenue sur {appname}",
    "code_title": "vérification",
    "phone_number": "Numéro de téléphone",
    "verification_email": "Veuillez saisir votre adresse e-mail",
    "verification_code": "Veuillez saisir le code de vérification",
    "captcha_code": "Code",
    "send_code": "Envoyer le code",
    "login": "Connexion",
    "agree": "En cliquant sur Connexion, vous acceptez ",
    "readme": "l'Accord Utilisateur",
    "msg_fail_login": "Échec de la connexion",
    "msg_success_login": "Connexion réussie",
    "msg_fail_user": "Erreur lors de la récupération des informations utilisateur. Voulez-vous réessayer ?",
    "sign_in_with": "Se connecter avec",
    "no_sms": "Vous n'avez pas reçu le SMS",
    "retry": "Renvoyer",
    "email": "E-Mail"
  },
  "confirm": {
    "deletecard": "Supprimer la carte",
    "addcard": "Saisir les détails de la carte",
    "title": "Confirmation de paiement",
    "paynow": "Paiement immédiat",
    "SMSConfirm": "Veuillez payer selon le SMS reçu sur votre téléphone et cliquer sur le bouton confirmer pour continuer.",
    "pay_label": "Montant",
    "auth_label": "Pré-autorisation",
    "price_tips": "Votre solde peut être retiré sur demande. Cela peut prendre 1 à 5 jours ouvrés pour apparaître sur votre compte de paiement.",
    "auth_tips": "Une pré-autorisation de {0}{1} est obligatoire. Le montant réel de la location sera déduit lorsque la batterie externe sera restituée.",
    "pay_type": "Veuillez sélectionner votre moyen de paiement préféré",
    "submit": "Confirmer le paiement",
    "msg_loading": "Chargement...",
    "msg_fail_title": "Avertissement",
    "msg_fail_payment": "Échec de l'initiation du paiement de caution",
    "msg_fail_order": "Échec de la création d'une commande de location",
    "msg_fail_support": "Le système n'est pas pris en charge",
    "msg_fail_confirm": "Confirmer",
    "msg_fail_retry": "Réessayer",
    "msg_fail_cancel": "Annuler",
    "payment_agreement": "J'accepte et j'accepte les conditions d'achat",
    "payment_agreement_tips": "Veuillez cocher pour accepter les conditions d'achat"
  },
  "mine": {
    "title": "Profil utilisateur",
    "wallet": "Mon portefeuille",
    "balance": "Mon solde",
    "deposit": "Dépôt",
    "wallet_in": "Recharger",
    "wallet_out": "Retirer",
    "wallet_log": "Journal du portefeuille",
    "rental_history": "Historique des locations",
    "payment_title": "Moyens de paiement",
    "download_app": "Télécharger l'application",
    "settings": "Paramètres",
    "help": "Aide",
    "logout": "Déconnexion",
    "login_tips": "Veuillez vous connecter",
    "msg_fail_title": "Erreur",
    "msg_fail_update": "Échec de la modification. Veuillez réessayer",
    "msg_loading": "Chargement...",
    "msg_fail_user": "Erreur lors de la récupération des informations utilisateur. Voulez-vous réessayer ?",
    "edit_profile": "Modifier le profil",
    "join_us": "Rejoignez-nous",
    "join_us_details": "Obtenez une station Blitz pour votre établissement"
  },
  "msg": {
    "appoffline": "L'application n'a pas encore été lancée, veuillez patienter",
    "deletecard": "Êtes-vous sûr de vouloir supprimer cette carte ?",
    "no_phone": "Le numéro de téléphone est requis",
    "loading": "Chargement...",
    "title": "Indication",
    "success": "Opération réussie",
    "error": "Erreur inconnue. Veuillez réessayer plus tard",
    "roleerror": "Permissions insuffisantes. Veuillez consulter l'administrateur.",
    "neterror": "Échec de la connexion réseau. Veuillez réessayer plus tard",
    "confirm": "Confirmer",
    "retry": "Réessayer",
    "cancel": "Annuler",
    "title_fail": "Avertissement",
    "vieworder": "Voir la commande",
    "success_payment": "Paiement terminé",
    "success_buy": "Achat terminé",
    "fail_payment": "Échec du paiement",
    "keyword": "Mot-clé",
    "ispayorder": "Veuillez confirmer si le paiement a été effectué",
    "unpay": "Impayé",
    "yespay": "Payé",
    "notopen": "Pas encore ouvert",
    "sure_logout": "Êtes-vous sûr de vouloir vous déconnecter ?"
  },
  "result": {
    "tips": "Veuillez suivre les instructions pour récupérer la batterie externe.",
    "download": "Télécharger l'application",
    "title": "Batterie externe éjectée avec succès",
    "gotit": "Compris",
    "price_plan": "Tarif",
    "msg_success": "Location réussie",
    "msg_tips_loading": "La batterie externe est en cours d'éjection, veuillez patienter...",
    "msg_result_loading": "Le résultat du paiement est en cours de confirmation...",
    "msg_fail_confirm": "Confirmer",
    "btn_usage": "Notice d'utilisation",
    "btn_return": "Notice de restitution",
    "deposit": "Dépôt",
    "msg_fail_content": "La requête a échoué. Veuillez réessayer.",
    "price_label": "par heure",
    "price_info": "Gratuit pendant les {mianfei} premières minutes，Un maximum journalier de {ccurrency}{fengding}. Le dépôt sera automatiquement déduit lorsque la location atteindra {ccurrency}{yajin}",
    "tips_1": "Votre batterie est prête. Suivez le témoin lumineux pour la récupérer",
    "tips_2": "Veuillez ranger les câbles et insérer la batterie externe dans l'emplacement avec le côté marqué des [flèches vers le bas]",
    "msg_note_usage": "La batterie externe est équipée de 3 types de câbles, veuillez choisir celui dont vous avez besoin pour votre appareil.",
    "msg_note_return": "Veuillez ranger les câbles et insérer la batterie externe dans l'emplacement avec le côté marqué des [flèches vers le bas]",
    "return_info": "Lors de la restitution, assurez-vous que les câbles sont bien rangés et insérez le côté avec les puces métalliques dans une prise disponible jusqu'à ce qu'il atteigne le fond et se stabilise.",
    "download_tips": "Pour louer notre batterie externe, vous pouvez choisir l'une des options suivantes",
    "confirm_transaction": "Confirmer la transaction"
  },
  "result_msg": {
    "loading": "Chargement...",
    "refresh": "Actualiser"
  },
  "order": {
    "title": "Historique des locations",
    "in_use": "En cours",
    "ended": "Terminée",
    "msg_error": "La requête a échoué",
    "order_number": "N°",
    "order_details": "Détails de la commande",
    "order_zj_shop": "Lieu de location",
    "order_zj_time": "Heure de location",
    "order_gh_shop": "Lieu de restitution",
    "order_gh_time": "Heure de restitution",
    "order_use_time": "Durée d'utilisation",
    "order_amount": "Montant total",
    "not_on_rent": "Pas en location",
    "renting": "En location",
    "undone": "Non terminé",
    "returned": "Restitué",
    "questions": "Questions",
    "timeout_to_return": "Retard de restitution",
    "suspended_for_billing": "Suspendu pour facturation"
  },
  "order_item": {
    "order_number": "N°",
    "venue_rented": "Lieu de retrait",
    "time_rented": "Heure de retrait",
    "venue_returned": "Lieu de restitution",
    "time_returned": "Heure de restitution",
    "charge_standard": "Tarif",
    "charge_standard_info": "{pJifei} {pCurrency} par heure (premières {pMian} minutes gratuites)",
    "rent_occurred": "Location effectuée",
    "returned": "Restitué",
    "unreturned": "Non restitué",
    "type_0": "Non terminée",
    "type_1": "En location",
    "type_2": "Annulée",
    "type_3": "Restituée",
    "type_4": "Erreur survenue",
    "type_5": "Dépassement",
    "min": "Min",
    "payment": "Paiement",
    "unpay": "Impayé"
  },
  "setting": {
    "title": "Paramètres",
    "lang": "Langue",
    "user_agreement": "Accord Utilisateur",
    "privacy_policy": "Politique de confidentialité",
    "time_zone": "Fuseau horaire",
    "logout": "Se déconnecter"
  },
  "help": {
    "title": "Aide",
    "faq": "FAQ",
    "rentals": "Locations",
    "venues": "Lieux",
    "payments": "Paiements",
    "user_guide": "Guide utilisateur",
    "contact_us": "Contactez-nous",
    "call_us": "Appelez-nous",
    "send_email": "Envoyer un e-mail"
  },
  "wallet_in": {
    "title": "Recharge du solde",
    "price_label": "Montant de recharge",
    "price_placeholder": "Veuillez saisir le montant de recharge",
    "balance": "Solde actuel",
    "price_auto": "Choisir un montant de paiement",
    "price_tips": "Votre solde peut être retiré sur demande. Cela peut prendre 1 à 5 jours ouvrés pour apparaître sur votre compte de paiement.",
    "submit": "Soumettre",
    "loading": "Chargement...",
    "paying": "Redirection vers la page de paiement...",
    "msg_title": "Conseils",
    "msg_fail_order": "Échec de la création de l'ordre de recharge",
    "msg_fail_payment": "Échec de l'initiation du paiement de recharge",
    "msg_fail_retry": "Réessayer"
  },
  "wallet_out": {
    "title": "Retrait",
    "price_label": "Montant du retrait",
    "price_placeholder": "Veuillez saisir le montant du retrait",
    "balance": "Solde actuel",
    "balance_all": "Tout retirer",
    "deposit": "Dépôt",
    "deposit_tips": "Il y a une commande de location en cours. Le dépôt de Ksh{pyajin} n'est pas remboursable",
    "submit": "Soumettre",
    "apply": "Appliquer",
    "confirm": "Confirmer",
    "loading": "Chargement...",
    "msg_fail_price": "Le montant du retrait est incorrect",
    "msg_fail_balance": "Le montant du retrait ne peut pas dépasser le solde actuel",
    "msg_fail_submit": "Veuillez remplir toutes les informations requises",
    "msg_title": "Erreur",
    "msg_success_content": "Remboursement réussi",
    "confirmtitle": "Conseils",
    "confirmcontent": "Le portefeuille actuel ne prend pas en charge le retrait en espèces. Veuillez enregistrer vos coordonnées pour un traitement manuel du remboursement",
    "payee_name": "Nom du bénéficiaire",
    "payee_bankcard": "Numéro de carte bancaire",
    "payee_phone": "Téléphone",
    "cancelText": "Annuler",
    "confirmText": "Postuler à nouveau"
  },
  "map": {
    "在线": "Ouvert",
    "离线": "Fermé",
    "title": "Station à proximité",
    "result_msg": "Aucune station trouvée à proximité",
    "msg_title": "erreur",
    "no_support": "Désolé ! Votre navigateur ne prend pas en charge les services de localisation",
    "my_position": "Ma position",
    "distance": "Distance :",
    "shop_time": "Horaires",
    "free": "Disponible à la location",
    "return": "Emplacements vides disponibles",
    "shop_title": "Détails du lieu",
    "address": "Adresse",
    "go_here": "Aller ici",
    "nav_help": "Aide",
    "nav_search": "Rechercher",
    "locate": "Localiser",
    "scan": "Scanner le QR code"
  },
  "scanQr": {
    "NotAllowedError": "Vous devez autoriser l'accès à la caméra",
    "NotFoundError": "Il n'y a pas de caméra sur cet appareil",
    "NotSupportedError": "Contexte sécurisé requis (HTTPS, localhost)",
    "NotReadableError": "La caméra est en cours d'utilisation",
    "OverconstrainedError": "L'installation de la caméra n'est pas appropriée",
    "StreamApiNotSupportedError": "Ce navigateur ne prend pas en charge l'API de streaming"
  },
  "payment": {
    "payment_title": "Moyens de paiement",
    "pay_type": "Veuillez ajouter les détails de votre carte",
    "add_payment_card": "Ajouter une carte de paiement",
    "add_payment": "ajouter un paiement"
  },
  "shop": {
    "title": "Station à proximité",
    "search_station": "Rechercher une station",
    "search_station_tips": "Veuillez saisir le nom de la station",
    "shop_power_banks": "Batteries externes",
    "shop_empty_slots": "Emplacements vides",
    "shop_address": "Adresse",
    "shop_business_hours": "Horaires d'ouverture",
    "shop_directions_station": "Obtenir l'itinéraire vers la station",
    "shop_scan_qrcode": "Scanner le QR code"
  },
  "time": {
    "days": "Jours",
    "hours": "Heures",
    "minutes": "Minutes"
  },
  "guide_page": {
    "title1": "Localiser une station",
    "title2": "Scanner le QR code",
    "title3": "Rechargez en déplacement !",
    "title4": "Restituez n'importe où.",
    "tips1": "Trouvez votre station Bini la plus proche.",
    "tips2": "Scannez le QR code sur la station en utilisant l'application Bini sur votre téléphone pour déverrouiller votre batterie externe.",
    "tips3": "Déverrouillez une batterie externe depuis n'importe quelle station et restez chargé où que vous alliez !",
    "tips4": "Insérez la batterie externe dans N'IMPORTE LAQUELLE de nos stations la plus proche de votre emplacement et à votre convenance.",
    "next": "Suivant",
    "skip": "Passer"
  },
  "invite": {
    "title": "Rejoindre Bini",
    "tips": "Lorsque votre ami se connecte, vous obtenez tous les deux des minutes de recharge gratuites ! ",
    "text": "Dites à un ami de scanner votre QR code ci-dessous, ou ajoutez simplement votre code promo personnel dans la section coupons de l'application Bini.",
    "coupon_code": "Code promo personnel"
  },
  "coupon": {
    "title": "Promotions",
    "expires": "Expire le",
    "coupon_btn": "Ajouter un code promo",
    "coupon_tips": "Astuce : Parrainez un ami",
    "code": "Code",
    "add_promos": "Ajouter des promotions"
  },
  "about": {
    "title": "À propos de nous",
    "text": "Bini vous garde connecté en permanence, grâce à notre réseau de stations de recharge pour appareils mobiles.",
    "leam_more": "En savoir plus sur nous sur :",
    "user_agreement": "Accord utilisateur & Conditions générales",
    "privacy_policy": "Politique de confidentialité",
    "social_media": "Réseaux sociaux"
  },
  "borrow": {
    "title": "Confirmation",
    "type": "ios, type-c",
    "billing": "{currencyName}{jifei}/{pjifeiDanwei}{priceUnit} Max.{currencyName}{fengding}/Jour",
    "return": "Restituer à n'importe quelle station de recharge disponible",
    "borrow_btn": "Commencer la location",
    "deposit": "Empreinte bancaire de {yajin}{currencyName}",
    "deposit_tips": "Débitée uniquement si la batterie n'est pas restituée."
  },
  "profile": {
    "title": "Profil",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "E-mail",
    "save_change": "Enregistrer les modifications"
  }
};
